// let baseUrl = "http://wumei.live:9666"; // 测试
// let baseUrl = "http://81.70.246.254:9666"; //测试
// let baseUrl = "http://49.232.214.97:9666"; //测试
// let baseUrl = "http://192.168.0.120:9666"; //本地测试
// let baseUrl = "http://localhost:8080/api";
// let baseUrl = "http://47.108.196.143:9666"; // 生产
// let baseUrl = 'http://api.rjt100.cn'  // 生产
//let baseUrl = "http://49.232.214.97:9666/api"; //生产
// let baseUrl = "http://172.168.10.246:9666";
let baseUrl = "/api";

// let baseUrl = "http://49.232.133.247:9666";
if (process.env.NODE_ENV == "devk8s") {
  // baseUrl = "http://140.143.241.125:31293";
} else if (process.env.NODE_ENV == "development") {
  //baseUrl = "http://140.143.243.176:9666";
  //baseUrl="http://localhost:9666";
  // baseUrl="http://tch.rjt100.com:9666"
} else {
  // baseUrl =
  //   location.protocol +
  //   "//" +
  //   location.host +
  //   "/" +
  //   process.env.NODE_ENV +
  //   "/api/";
  // baseUrl = "http://49.232.133.247:9666/"+process.env.NODE_ENV+"/api/";
}
console.log(location);
export default baseUrl;
